import React, { useEffect, useState } from "react"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@app"
import { object, string } from "yup"
import { autoEuropeDrawerData, autoEuropeDrawerErrors } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeTargetPosition() {
	const [value, setValue] = useState(autoEuropeDrawerData.peek().targetPosition ?? '')

	const { errors, isValid } = useValidatorSeeker({ targetPosition: value }, object({
		targetPosition: string()
			.nullable()
			.test("range", "Must be a whole number between 1 and 20", v => {
				if (v === null || v === '' || v === undefined) return true
				const n = Number(v)
				return Number.isInteger(n) && n >= 1 && n <= 20
			})
	}))

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, targetPosition: isValid }
	}, [JSON.stringify(errors)])

	const handleChange = (e) => {
		const raw = e.target.value
		setValue(raw)
		autoEuropeDrawerData.value = {
			...autoEuropeDrawerData.value,
			targetPosition: raw !== '' ? Number(raw) : null,
		}
	}

	return (
		<NumberFieldSeeker
			label="Target Position"
			placeholder="Any position"
			value={value}
			onChange={handleChange}
			error={errors?.targetPosition}
		/>
	)
}